import { Context, useContext } from 'react';

export class ContextNotProvidedError extends Error {
  constructor() {
    super('Cannot use the context without providing it in the parent component');
  }
}

export const useDefinedContext = <TContext>(
  contextProvider: Context<TContext | undefined>,
): TContext => {
  const context = useContext(contextProvider);

  if (!context) {
    throw new ContextNotProvidedError();
  }

  return context;
};